import React from "react";
import Navbar from "./Navbar";
import Title from "./Title";

function page1() {

    return (
        <section id='home' >
            <div className="page1">
                <Navbar />
                <div className="flex-container">
                    <Title />
                    <div className="flex-container-buyNFT">
                        <button className="buyNFT" id="buyNFT" onClick={() => { window.open("https://opensea.io/collection/armadillosnft-collection") }}>Buy NFT</button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default page1


